import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../Assets/logo-action.webp";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    function scrollHandler() {
      updateNavbar(window.scrollY >= 20);
    }
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const handleNavigation = (path) => {
    updateExpanded(false);
    navigate(path);
  };

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "navbar-sticky" : "navbar-transparent"}
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/" onClick={() => updateExpanded(false)}>
          <img src={logo} className="img-fluid action-logo" alt="Act!on Logo" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => updateExpanded(expand ? false : "expanded")}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end onClick={() => updateExpanded(false)}>
              INICIAL
            </Nav.Link>

            <NavDropdown title="SERVIÇOS" id="nav-dropdown-servicos">
              <NavDropdown.Item onClick={() => handleNavigation("/servicos")}>
                CONSULTORIA
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavigation("/faas")}>
                FAAS
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item
                href="https://frontbpo.com/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => updateExpanded(false)}
              >
                FRONTBPO
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/equipe" onClick={() => updateExpanded(false)}>
              EQUIPE
            </Nav.Link>

            <NavDropdown title="CONTEÚDO" id="nav-dropdown-conteudo">
              <NavDropdown.Item onClick={() => handleNavigation("/blog")}>
                BLOG
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavigation("/actioncast")}>
                ACTIONCAST
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link
              href="https://www.cliente.actionexec.com/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => updateExpanded(false)}
              className="external-link"
            >
              PORTAL DO CLIENTE
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
